import styled from 'styled-components';
import { getTextStyle } from 'utils/getTextStyle';

export type LegalTextProps = {
    type: 'TERMS_OF_USE' | 'PRIVACY_POLICY';
    children: string;
};

export const LegalDocumentRedirectText = styled.a`
    ${getTextStyle('BodySmallSemiBold')};
`;

export const LegalText = ({ type, children }: LegalTextProps) => {
    const placeToNavigate: Record<LegalTextProps['type'], string> = {
        PRIVACY_POLICY: 'https://www.elfedu.pl/dokumenty/polityka-prywatnosci',
        TERMS_OF_USE: 'https://www.elfedu.pl/dokumenty/regulamin',
    };

    return (
        <LegalDocumentRedirectText href={placeToNavigate[type]} target="_blank">
            {children}
        </LegalDocumentRedirectText>
    );
};
